const Images = {
    mapBackground: require('./Home/HOME-image-map.png'),
    mapBackgroundOpacity: require('./Home/HOME-image-map-opacity.png'),
    mapBackgroundLightRed: require('./mapa-morado.png'),
    mapBackgroundLife: require('./map_mundi_vida.png'),
    mapBackgroundNoLife: require('./map_mundi_no_vida.png'),
    homeImage1: require('./Home/HOME-image1.png'),
    homeImage2: require('./Home/HOME-image2.png'),
    homeImage3: require('./Home/HOME-image3.png'),
    homeImage4: require('./Home/HOME-image4.png'),
    homeImage5: require('./Home/HOME-image5.png'),
    homeImage6: require('./Home/HOME-image6.png'),
    homeImage7: require('./Home/HOME-image7.png'),
    homeImage8: require('./Home/HOME-image8.png'),
    homeImage9: require('./Home/HOME-image9.png'),
    homeImage10: require('./Home/HOME-image10.png'),
    homeImage11: require('./Home/HOME-image11.png'),
    studioServices: require('./NAVBAR-studio-services.png'),
    expand: require('./ic_expand.png'),
    menu: require('./ic_menu.png'),
    close: require('./ic_close.png'),
    logoMapfreWhite: require('./Logo Vector Blanco.png'),
    logoMapfre: require('./Logo Vector Rojo.png'),
    logoWhiteBgEconomics: require('./mapfre-economics-white-bg.jpg'),
    logoRedBgEconomics: require('./mapfre-economics-red-bg.jpg'),
    logoMapfre2: require('./mapfre-logo.jpg'),
    logoMapfreBrandWhite: require('./LOGO-Mapfre-white.png'),
    isotypeMapfreEconomics: require('./isotype-mapfre-economics.svg'),
    fb: require('./socialMedia/fb.png'),
    ig: require('./socialMedia/ig.png'),
    linkedin: require('./socialMedia/linkedin.png'),
    wsp: require('./socialMedia/wsp.png'),
    yt: require('./socialMedia/yt.png'),
    bridge:  require('./bridge.png'),
    icons: {
      info: require('./circle-info-icon.svg'),
      graphs: require('./circle-graphs-icon.svg'),
      downloadPdfWhite: require('./circle-download-pdf-white-icon.svg'),
      downloadPdfGrey: require('./circle-download-pdf-grey-icon.svg'),
    }
};

export default Images;
